import { DurationTimeConfig } from './DurationForm.types';

export const getPlural = (num: number | void, singular: string, plural?: string): string =>
  Number(num) === 1 ? singular : plural || `${singular}s`;

export const isValidNumber = (value: any, opts: DurationTimeConfig = {}): boolean => {
  const num = Number(value);

  if (Number.isNaN(num)) return false;

  const { min = -Infinity, max = Infinity } = opts;

  return value >= min && value <= max;
};
